import { render } from "./signUpOk.vue?vue&type=template&id=3a7e2901"
import script from "./signUpOk.vue?vue&type=script&lang=js"
export * from "./signUpOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__